import React from "react";

import { useButton } from "./hooks";

export const TutorialButton = React.memo(() => {
  const { getButtonProps } = useButton();
  return (
    <button {...getButtonProps()}>
      <span>?</span>
    </button>
  );
});

TutorialButton.displayName = "TutorialButton";
